import { InvoiceType } from "./enums/invoice-type.enum";

export class CustomerInvoiceResponse {
    public totalCount: number;
    public customerInvoices: CustomerInvoice[];

    constructor(totalCount: number, customerInvoices: CustomerInvoice[]) {
        this.totalCount = totalCount;
        this.customerInvoices = customerInvoices;
    }
}

export class CustomerInvoice {
    public documentNumber: string;
    public documentNumber2: string;
    public invoiceDate: Date;
    public invoiceType: InvoiceType;
    public amount: number;
    public outstandingAmount: number;
    public seqVerkoopkop: number;
    public advanceInvoice: boolean;
    public reportVersion: string;
    public hasConsumptions: boolean;

    constructor(
        documentNumber: string,
        documentNumber2: string,
        invoiceDate: Date,
        invoiceType: InvoiceType,
        amount: number,
        outstandingAmount: number,
        seqVerkoopkop: number,
        advanceInvoice: boolean,
        reportVersion: string,
        hasConsumptions: boolean
    ) {
        this.documentNumber = documentNumber;
        this.documentNumber2 = documentNumber2;
        this.invoiceDate = invoiceDate;
        this.invoiceType = invoiceType;
        this.amount = amount;
        this.outstandingAmount = outstandingAmount;
        this.seqVerkoopkop = seqVerkoopkop;
        this.advanceInvoice = advanceInvoice;
        this.reportVersion = reportVersion;
        this.hasConsumptions = hasConsumptions;
    }

}

export function jsonToCustomerInvoice(json: any): CustomerInvoice {
    return new CustomerInvoice(
        json.documentNumber,
        json.documentNumber2,
        new Date(json.invoiceDate),
        json.invoiceType,
        json.amount,
        json.outstandingAmount,
        json.seqVerkoopkop,
        json.advanceInvoice,
        json.reportVersion,
        json.hasConsumptions
    );
}

export function jsonToCustomerInvoiceResponse(json: any): CustomerInvoiceResponse {
    const customerInvoices = json.customerInvoices.map((invoice: any) => jsonToCustomerInvoice(invoice));
    return new CustomerInvoiceResponse(json.totalCount, customerInvoices);
}